export type AnalyticalItem = {
	sessionId: string;
	userOddsSession: string;
	userId?: number;
	action: AnalyticalItemAction[];
};

export type AnalyticalItemAction = {
	action_at: number;
	action_id: string;
	action_type: ActionType;
	action_data: ActionData;
};

export enum ActionType {
	ADD = 'add',
	REMOVE = 'remove',
}

export enum ActionEventType {
	LIVE = 'live',
	PREMATCH = 'prematch',
}

export enum StakeMethod {
	MANUAL = 'manual',
	LAST = 'last',
	ALLIN = 'allin',
	DEFINED = 'defined',
	DEFAULT = 'default',
}

type ActionData = {
	bet_selected_1: number;
	bet_selected_2: number;
	bet_selected_3: number;
	event_category_1: number;
	event_category_2: number;
	event_count: number;
	event_id: number;
	event_type: string;
	odds: number;
	origin_url: string;
	participants: string;
};

const BetslipAnalyticsApiWrapper = (requests: any) => {
	return {
		postBetslipAnalytics: (body: AnalyticalItem) => {
			return requests.post('/analytics/betslips', body);
		},
	};
};

export default BetslipAnalyticsApiWrapper;
